$(document).ready(function () {
  $('.maginfy-icon').on('click', function () {
    $.fancybox.open(
      $('[data-fancybox="gallery"]'),
      {
        buttons: ["close"],
        arrows: false,        
        clickContent: "next", 
        loop: false,
      }
    );
  });
});
document.addEventListener("DOMContentLoaded", function () {
    const inputs = document.querySelectorAll(".field__input");

    inputs.forEach((input) => {
        const label = input.closest(".field").querySelector(".field__label"); 

        if (label) {
            // Toggle label on page load
            toggleLabel(input, label);

            // Listen for input changes
            input.addEventListener("input", () => toggleLabel(input, label));
            input.addEventListener("blur", () => toggleLabel(input, label));
        }
    });

    function toggleLabel(input, label) {
        if (input.value.trim() !== "") {
            label.classList.add("hidden");
        } else {
            label.classList.remove("hidden");
        }
    }
});

$(document).ready(function () {
   function initializePagination() {
    var items = $(".review-col-block");
    var numItems = items.length;
    var perPage = 4;
    let nextbtn = "<svg xmlns='http://www.w3.org/2000/svg' width='23' height='14' viewBox='0 0 23 14' fill='none'><path d='M15.749 1L21.5794 6.83034L15.749 12.6607' stroke='#1A1A1A' stroke-width='1.16607'/><path d='M21.0937 6.83008L0.6875 6.83008' stroke='#1A1A1A' stroke-width='1.16607'/></svg>";
    items.slice(perPage).hide();

    $('#pagination-container').pagination({
        items: numItems,
        itemsOnPage: perPage,
        nextText: nextbtn,
        prevText: "",
        ellipses: true,
        onPageClick: function (pageNumber, event) {
            if (event) {
                event.preventDefault();
            }
            var showFrom = perPage * (pageNumber - 1);
            var showTo = showFrom + perPage;
            items.hide().slice(showFrom, showTo).show();
        }
    });
}
        if ($(".review-col-block").length > 0) {
            console.log("Blocks loaded, initializing pagination...");

            initializePagination();
        }

    $(document).on("shopify:section:load", function () {
        console.log("Shopify section reloaded");
        initializePagination();
    });
});




/////////////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////
////// Pagination script //////////////////////

 document.addEventListener('DOMContentLoaded', function () {
    var grid = document.querySelector('.review-grid-content');
    var items = document.querySelectorAll('.review-col-block');
    var perPage = 4;
    var currentCount = perPage;

    function initializeLoadMore() {
        // Hide all reviews except the first set
        items.forEach((item, index) => {
            if (index >= perPage) {
                item.style.display = "none";
            }
        });
        // Load More button click event
        document.getElementById("pagination-container")?.addEventListener("click", function () {
            items.forEach((item, index) => {
                if (index >= currentCount && index < currentCount + perPage) {
                    item.style.display = "block";
                }
             
            });

            currentCount += perPage;
            // Re-layout Masonry after loading more reviews
            if (grid && typeof Masonry !== "undefined") {
                masonry.layout();
            }
        });
    }

    // Initialize Masonry layout
    if (grid) {
        var masonry = new Masonry(grid, {
            itemSelector: '.review-col-block',
            columnWidth: '.review-col-block',
            gutter: 36, /* Match the gap from the screenshot */
            percentPosition: true,
            transitionDuration: '0.2s' /* Smooth transitions when items are repositioned */
        });

        // Ensure Masonry updates when images load
        grid.addEventListener('load', function () {
            masonry.layout();
        }, true);
    }

    // Initialize Load More if reviews exist
    if (items.length > 0) {
        initializeLoadMore();
    }

    // Reinitialize on Shopify section reload
    document.addEventListener("shopify:section:load", function () {
        initializeLoadMore();
        if (grid && typeof Masonry !== "undefined") {
            masonry.layout();
        }
    });
});

///////////////////////////////////////////////////////////////////////////////
// Custom Tab Section

$(document).ready(function(){
	
	$('ul.tabs li').click(function(){
		var tab_id = $(this).attr('data-tab');

		$('ul.tabs li').removeClass('current');
		$('.tab-content').removeClass('current');

		$(this).addClass('current');
		$("#"+tab_id).addClass('current');
	})

});
//////////////////////////////////////////////////////////////////////////
// Image Tab 
$(document).ready(function(){
	
	$('ul.tabs-img li').click(function(){
		var tab_id = $(this).attr('data-tab-img');

		$('ul.tabs-img li').removeClass('current');
		$('.tab-content-img').removeClass('current');

		$(this).addClass('current');
		$("#"+tab_id).addClass('current');
	})

})

/////////////////////////////////////////////////////////////////////////
// Member Slider

$(document).ready(function(){
      $('.my-slider').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        infinite: false,
        autoplay: true,
        autoplaySpeed: 4000,
        draggable: false,
        speed: 1000,
        prevArrow: $('.prev-btn'),
        nextArrow: $('.next-btn'),
        responsive: [
      {
        breakpoint: 1440,
        settings: {
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
        }
      }
    ]
      });
});

////////////////////////////////////////////////////////////

// function updateSupportText() {
//     var selectedIndex = $('.select__select').prop('selectedIndex'); 
//     var supportText = selectedIndex === 0 ? "Support to 6 months" : "Support to 12 months"; 

//     $('.time-period').text(supportText);
// }

// // Trigger on variant change
// $(document).on('change', '.select__select', function () {
//     updateSupportText();
    
//     // Reapply after Shopify updates the variant details
//     setTimeout(updateSupportText, 500);
// });

function updateSupportTextAndPrice() {
    var $select = $('.select__select');
    var selectedOption = $select.find(':selected').attr('data-support-text'); // Get selected option

    $('.time-period').text(selectedOption);
}
 updateSupportTextAndPrice();
// Trigger on variant change
$(document).on('change', '.select__select', function () {
    updateSupportTextAndPrice();
    
    // Reapply after Shopify updates the variant details
    setTimeout(updateSupportTextAndPrice, 1000);
});

// animations


document.addEventListener('DOMContentLoaded', () => {
  window.addEventListener('load', () => {
    document.body.classList.add('loaded');
  });
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
        observer.unobserve(entry.target);
      }
    });
  }, {
    threshold: 0.1, 
    rootMargin: '0px 0px -50px 0px'
  });
  document.querySelectorAll('.animate-on-scroll').forEach(el => {
    observer.observe(el);
  });
});
document.addEventListener("DOMContentLoaded", function () {
  const container = document.querySelector(".shopify-email-marketing-confirmation__container");
  if (!container) return;
  const heading = container.querySelector("h1");
  if (heading) {
    heading.textContent = "Thank You.";
    heading.style.display = "block";
  }
});
document.querySelectorAll('.audit-features .audit_label').forEach((button) => {
  button.addEventListener('click', (e) => {

    e.preventDefault();
    if (button.classList.contains('active')) {
      button.classList.remove('active');
    } else {
      document.querySelectorAll('.audit-features .audit_label').forEach((btn) => {
        btn.classList.remove('active');
      });
      button.classList.add('active');
    }

  });
});







